module.exports = __webpack_public_path__ + "0d8b5bb0cec8cc2f6c304cf30fabd95d.svg";